module.exports = __webpack_public_path__ + "static/media/ios-folder-open.8e966840.svg";